import React, { createContext, useEffect, useState } from "react";
import {
  userDetailsApi,
  editUserInfo,
  deleteProfilePicApi,
  generateMfaCode,
  verifyAppMfaCode,
  verifyPhoneNumberAPI,
  verifyOtpAPI,
} from "../../../api/Api";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import routeConstants from "../../../constants/routeConstants.json";
import { validateMobileNumber } from "../../../utils/service";
import axios from "axios";
import { useGlobalContext } from "../../../GlobalState/GlobalContext";
import { handleApiError } from "../../../constants/Constants";

export const EditProfileContext = createContext({});
export const EditProfileContextProvider = ({ children }) => {
  const [spinnerStatus, setSpinnerStatus] = useState(false);

  // const [currentUserDetails, setCurrentUserDetails] = useState({});
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState();
  const [role, setRole] = useState("");
  const [userId, setUserId] = useState();

  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [invalidNumberMsg, setInvalidNumberMsg] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState("");
  const [statusCode, setStatusCode] = useState();
  const [invalidImageMsg, setInvalidImageMsg] = useState("");
  const [editNotificationPreference, setEditNotificationPreference] = useState(
    []
  );
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setError("");
  };
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showDeleteErrorPopup, setShowDeleteErrorPopup] = useState(false);
  const [verifyQrPopup, setVerifyQrPopup] = useState("");
  const [errorQrPopup, setErrorQrPopup] = useState("");

  const [mobile, setMobile] = useState();
  const [mobileVerified, setMobileVerified] = useState(false);
  const [verification, setVerifcation] = useState(false); // for identifying the success popup for mobile verification

  const [qrCode, setQrCode] = useState("");
  const [authCode, setAuthCode] = useState();
  const [verifyMfaCode, setVerifyMfaCode] = useState(0);

  const [mfaDetails, setMfaDetails] = useState("Disabled");

  const [mfaCheckBox, setMfaCheckBox] = useState();
  const [multiFactorAuthApp, setMultiFactorAuthApp] = useState();
  const [multiFactorEmail, setMultiFactorEmail] = useState();
  const [multiFactorSms, setMultiFactorSms] = useState();

  const [showMobileVerification, setShowMobileVerification] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [enteredCode, setEnteredCode] = useState(["", "", "", "", "", ""]);

  const [showQrAlert, setShowQrAlert] = useState();
  const [authType, setAuthType] = useState("Disabled");
  const [authToken, setAuthToken] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const { globalProfile, setGlobalProfile } = useGlobalContext();

  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState(false);
  const [statusValue, setStatusValue] = useState(false);

  const navigate = useNavigate();

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const fullImageUrl = profileImageUrl ? profileImageUrl : false;

  useEffect(() => {
    getUserDetails();
  }, []);

  const getUserDetails = async () => {
    try {
      setSpinnerStatus(true);
      const userDetails = await userDetailsApi();
      setName(userDetails?.data?.data?.profile?.name);
      setEmail(userDetails?.data?.data?.profile?.email);
      setPhoneNumber(userDetails?.data?.data?.profile?.mobile);
      setMobile(userDetails?.data?.data?.profile?.mobile);
      setRole(userDetails?.data?.data?.profile?.role?.name);
      setProfileImageUrl(userDetails?.data?.data?.profile?.profileImage);
      setMobileVerified(userDetails?.data?.data?.profile?.mobileVerified);

      // setGlobalProfile(userDetails?.data?.data?.profile?.profileImage);

      setMfaDetails(
        userDetails?.data?.data?.profile?.multiFactorAuthentication
      );
      setUserId(userDetails?.data?.data?.profile?._id);
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  const generateMfa = async () => {
    try {
      const mfaCode = await generateMfaCode();
      setAuthToken(mfaCode?.data?.data?.authToken);
      setQrCode(mfaCode?.data?.data?.qrCode);
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  const verifyAppMfa = async (userId, code, authToken) => {
    try {
      const verifyCode = await verifyAppMfaCode(userId, code, authToken);
      setVerifyMfaCode(verifyCode?.status);

      if (verifyCode?.status === 200) {
        onSubmitEditedInfo();
        setShowSuccessPopup(true);
      } else {
        setAuthCode();
      }
    } catch (error) {
      setErrorQrPopup(true);
      setAuthCode();
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  const handleCheckboxToggle = (type, field) => {
    setEditNotificationPreference((prevPreferences) =>
      prevPreferences.map((item) =>
        item.type === type ? { ...item, [field]: !item[field] } : item
      )
    );
  };

  const handleMultiFactorCheckboxClick = () => {
    //  This is for unchecking both other checkboxes when
    //  Multifactor checkbox is clicked
    setMfaCheckBox((prev) => {
      const newAuthState = !prev;
      if (!newAuthState) {
        setMultiFactorEmail(false);
        setMultiFactorAuthApp(false);
        setMultiFactorSms(false);
        setAuthType("Disabled");
      }
      return newAuthState;
    });
  };

  const phoneNumberOnBlur = () => {
    if (!validateMobileNumber(phoneNumber)) {
      setInvalidNumberMsg("Enter 10-digit number");
    } else {
      setInvalidNumberMsg("");
    }
  };

  const handleThemeBtnClick = () => {
    if (mfaDetails === "App") {
      onSubmitEditedInfo();
      return;
    }

    if (!mfaCheckBox) {
      // Allow submission if MFA checkbox is not checked
      onSubmitEditedInfo();
      return;
    }

    // Handle MFA cases
    if (authType === "App") {
      generateMfa();
      setShowQrAlert(true);
    } else if (authType === "Email") {
      onSubmitEditedInfo();
    } else if (authType === "Sms") {
      if (!mobileVerified) {
        setShowMobileVerification(true);
      } else {
        onSubmitEditedInfo();
      }
    } else {
    }
  };

  const goToLogin = () => {
    removeCookie("x-access-token");
    navigate(routeConstants.LOGIN);
  };

  const onSubmitEditedInfo = async () => {
    let formDataInfo = new FormData();
    formDataInfo.append("mobile", phoneNumber);
    formDataInfo.append("multiFactorAuthentication", authType);

    if (file) {
      formDataInfo.append("profileImage", file);
    } else {
      formDataInfo.append("profileImage", "");
    }

    if (!invalidNumberMsg && !invalidImageMsg) {
      try {
        setSpinnerStatus(true);
        const response = await editUserInfo(formDataInfo);
        setStatusCode(response?.data?.statusCode);

        if (response?.data?.statusCode === 200) {
          setShowSuccessPopup(true); // Show success popup
          setSuccessMessage(response?.data?.message);
          setShowErrorPopup(false);
          setSpinnerStatus(false);
        }
      } catch (error) {
        setSpinnerStatus(false);
        setStatusValue(error?.response?.data?.statusCode);

        if (error?.response?.data?.statusCode === 400) {
          const errorMessage = error?.response?.data?.message;
          setPopupMessage(errorMessage);
          setShowErrorPopup(true);
          setShowSuccessPopup(false);
          setButtonText("Try Again");
        } else if (
          error?.response?.data?.statusCode === 401 ||
          error?.response?.data?.statusCode === 403
        ) {
          const errorMessage = error?.response?.data?.message;
          setPopupMessage(errorMessage);
          setShowErrorPopup(true);
          setShowSuccessPopup(false);
          setButtonText("Login");
        } else {
          setPopupMessage("Something went wrong...");
          setShowErrorPopup(true);
          setShowSuccessPopup(false);
          setButtonText("Try Again");
        }
      }
    }
  };

  const handleDelete = async () => {
    setShowDeletePopup(false);
    setShowErrorPopup(false);
    try {
      const response = await deleteProfilePicApi();
      if (response.status === 200) {
        setShowDeletePopup(true);
        // setShowErrorPopup(true);
        setPopupMessage(response?.data?.message);
        handleClose();
      } else {
        setShowDeleteErrorPopup(true);
      }
    } catch (error) {
      setShowDeleteErrorPopup(true);
      handleClose();
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  const validateImage = (image) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const maxFileSize = 2 * 1024 * 1024; // 2MB

    // Clear previous error messages
    setInvalidImageMsg("");

    // Validate file type
    if (!allowedTypes.includes(image.type)) {
      setInvalidImageMsg("Only JPEG, PNG, and JPG files are allowed");
      return false;
    }

    // Validate file size
    if (image.size > maxFileSize) {
      setInvalidImageMsg("File size should be less than 2MB");
      return false;
    }

    // No validation errors
    return true;
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    // const validationError = validateImage(selectedFile);

    if (!validateImage(selectedFile)) {
      setError("Only JPEG, PNG, and JPG files under 2MB are allowed");
      setFile(null);
      setPreview(null);
    } else {
      setError("");
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
      handleClose();
    }
  };

  const phoneNumberOnChange = (e) => {
    const value = e.target.value;

    if (value != mobile) {
      setMobileVerified(false);
    } else {
      setMobileVerified(true);
    }

    setPhoneNumber(value);
    if (!validateMobileNumber(value)) {
      setInvalidNumberMsg("Enter 10-digit number");
    } else {
      setInvalidNumberMsg("");
    }
  };
  const sendCodeSubmit = () => {
    verifyPhoneNumber();
  };

  const sendOtpSubmit = async () => {
    const otpCode = enteredCode.join("");
    const data = {
      userId: userId,
      code: otpCode,
      mobile: phoneNumber,
    };
    setSpinnerStatus(true);
    try {
      setSpinnerStatus(true);
      const response = await verifyOtpAPI(data);
      setStatusCode(response?.data?.statusCode);
      if (response?.data?.statusCode === 200) {
        setShowSuccessPopup(true); // Show success popup
        setSuccessMessage(response?.data?.message);
        setShowErrorPopup(false);
        setSpinnerStatus(false);
        setShowOtpModal(false);
        setEnteredCode(["", "", "", "", "", ""]);
        setShowMobileVerification(false);
        setVerifcation(true);
      }
    } catch (error) {
      setSpinnerStatus(false);
      setShowOtpModal(true);
      setStatusValue(error?.response?.data?.statusCode);
      if (error?.response?.data?.statusCode === 400) {
        const errorMessage = error?.response?.data?.message;
        setPopupMessage(errorMessage);
        setShowErrorPopup(true);
        setShowSuccessPopup(false);
        setButtonText("Try Again");
      } else if (
        error?.response?.data?.statusCode === 401 ||
        error?.response?.data?.statusCode === 403
      ) {
        const errorMessage = error?.response?.data?.message;
        setPopupMessage(errorMessage);
        setShowErrorPopup(true);
        setShowSuccessPopup(false);
        setButtonText("Login");
      } else {
        setPopupMessage("Something went wrong...");
        setShowErrorPopup(true);
        setShowSuccessPopup(false);
        setButtonText("Try Again");
      }
    }
  };
  const resendOtpCode = () => {
    verifyPhoneNumber();
  };
  //api - verifiy phone number
  const verifyPhoneNumber = async () => {
    setSpinnerStatus(true);
    try {
      setSpinnerStatus(true);
      const response = await verifyPhoneNumberAPI({ mobile: phoneNumber });
      setStatusCode(response?.data?.statusCode);
      if (response?.data?.statusCode === 200) {
        setShowErrorPopup(false);
        setSpinnerStatus(false);
        setShowOtpModal(true);
        setShowMobileVerification(false);
      }
    } catch (error) {
      setSpinnerStatus(false);
      setStatusValue(error?.response?.data?.statusCode);
      if (error?.response?.data?.statusCode === 400) {
        const errorMessage = error?.response?.data?.message;
        setPopupMessage(errorMessage);
        setShowErrorPopup(true);
        setShowSuccessPopup(false);
        setButtonText("Try Again");
      } else if (
        error?.response?.data?.statusCode === 401 ||
        error?.response?.data?.statusCode === 403
      ) {
        const errorMessage = error?.response?.data?.message;
        setPopupMessage(errorMessage);
        setShowErrorPopup(true);
        setShowSuccessPopup(false);
        setButtonText("Login");
      } else {
        setPopupMessage("Something went wrong...");
        setShowErrorPopup(true);
        setShowSuccessPopup(false);
        setButtonText("Try Again");
      }
    }
  };
  const providerValue = {
    name,
    role,
    email,
    phoneNumber,
    setName,
    phoneNumberOnChange,
    fullImageUrl,
    onSubmitEditedInfo,
    invalidNumberMsg,
    handleFileChange,
    preview,
    error,
    show,
    setShow,
    handleClose,
    handleShow,
    handleDelete,
    navigate,
    routeConstants,
    showSuccessPopup,
    showErrorPopup,
    showDeletePopup,
    showDeleteErrorPopup,
    setShowSuccessPopup,
    setShowErrorPopup,
    setShowDeletePopup,
    setShowDeleteErrorPopup,
    spinnerStatus,
    handleCheckboxToggle,
    setEditNotificationPreference,
    editNotificationPreference,
    generateMfa,
    qrCode,
    authCode,
    setAuthCode,
    mfaCheckBox,
    setMfaCheckBox,
    multiFactorAuthApp,
    setMultiFactorAuthApp,
    showQrAlert,
    setShowQrAlert,
    authType,
    setAuthType,
    userId,
    authToken,
    verifyAppMfa,
    multiFactorEmail,
    setMultiFactorEmail,
    multiFactorSms,
    setMultiFactorSms,
    handleMultiFactorCheckboxClick,
    verifyMfaCode,
    mfaDetails,
    verifyQrPopup,
    setVerifyQrPopup,
    errorQrPopup,
    setErrorQrPopup,
    handleThemeBtnClick,
    phoneNumberOnBlur,
    validateImage,
    setPreview,
    setError,
    popupMessage,
    successMessage,
    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    setErrorPopupMessage,
    buttonText,
    setButtonText,
    goToLogin,
    statusValue,
    setStatusValue,
    getUserDetails,
    showMobileVerification,
    setShowMobileVerification,
    enteredCode,
    setEnteredCode,
    sendCodeSubmit,
    showOtpModal,
    setShowOtpModal,
    phoneNumber,
    setPhoneNumber,
    sendOtpSubmit,
    resendOtpCode,
    verifyPhoneNumber,
    mobileVerified,
    verification,
  };

  return (
    <EditProfileContext.Provider value={providerValue}>
      {children}
    </EditProfileContext.Provider>
  );
};
